import { render, staticRenderFns } from "./EntendaLegislacao.vue?vue&type=template&id=46637939&scoped=true"
import script from "./EntendaLegislacao.vue?vue&type=script&lang=js"
export * from "./EntendaLegislacao.vue?vue&type=script&lang=js"
import style0 from "./EntendaLegislacao.vue?vue&type=style&index=0&id=46637939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46637939",
  null
  
)

export default component.exports